import React from 'react';
import { GrievanceFormContextType } from '../../../../services/types/Grievance';

const Context = React.createContext<GrievanceFormContextType>({
  genders: [],
  countries: [],
  countriesClaimant: [],
  channels: [],
  origins: [],
  mainTopics: [],
  subTopics: [],
  priorities: [],
  imminentRiskTypes: [],
  currentPhases: [],
  reload: () => {},
  loading: false,
});

export default Context;
